import {
  SUMMER_T_SHIRT_PROMO_TEST_KEY,
  useFeatureFlag,
  VISUAL_FILTERS_TEST
} from './constants/signalmizelyConstants';

export function visualFiltersTest() {
  return useFeatureFlag(VISUAL_FILTERS_TEST);
}

export function useSummerTShirtPromoTest() {
  return useFeatureFlag(SUMMER_T_SHIRT_PROMO_TEST_KEY);
}
